import { Component, OnInit, SimpleChanges, OnChanges, ElementRef } from '@angular/core';
import { AssessmentComponent } from '../assessment/assessment.component';
import { AlertService } from 'app/shared/services/alert.service';
import { QuestionAnswerPopulator } from 'app/shared/services/question-answer-populator.service';
import { Assessment } from 'app/shared/models/assessment';
import { QuestionSet } from 'app/shared/models/question-set';
import { Question } from 'app/shared/models/question';
import * as jQuery from "jquery";
import { QuestionType } from 'app/shared/models/question-type';

@Component({
  selector: 'dac-assessment-single-question-display',
  templateUrl: './assessment-single-question-display.component.html',
  styleUrls: ['./assessment-single-question-display.component.scss']
})
export class AssessmentSingleQuestionDisplayComponent extends AssessmentComponent implements OnInit, OnChanges {

  private _currentAssessment:Assessment;
  private _cachedDisplaySets:QuestionSet[];

  // TODO: stephen single question display doesn't currently handle branching and that's a harder problem to solve...
  constructor(alertService: AlertService, questionPopulator:QuestionAnswerPopulator, private element:ElementRef) { 
    super(alertService, questionPopulator);
    this.showInstructions();
  }

  ngOnInit() {
  }

  ngOnChanges(changes:SimpleChanges) {
    super.ngOnChanges(changes);
  }

  public handleListAnswer(questions:Question[]) {
    console.log("Set was answered.  Questions answered: ", questions);
    let skipAutoSubmit = questions.some((q) => {
      return q.type == QuestionType.Textbox || q.type == QuestionType.Checklist
    });
    if (!skipAutoSubmit) {
      // TODO: stephen there is a bug if the question is a Textbox it marks the textbox as answered with one character and tries to move
      // to the next set on every single character typed...
      this.nextSet();
    }
  }

  protected getQuestionSetsForDisplay(assessment:Assessment) {
    if (this._cachedDisplaySets
      && this._currentAssessment
      && this._currentAssessment == assessment) {
      return this._cachedDisplaySets;
    }
    else {
      this._currentAssessment = assessment;
      this._cachedDisplaySets = [];
    }
    // TODO: stephen this doesn't handle branching...
    let displaySetList = [];
    
    assessment.getQuestionSetsForDisplay();
    this.assessment.question_sets.forEach(qs => {
      let firstQuestion = true;
      qs.questions.forEach(q => {
        let displaySet = Object.assign(new QuestionSet(), qs);
        // only show the instructions on the first question of the set.
        displaySet.instructions = firstQuestion ? displaySet.instructions : "";
        firstQuestion = false;
        displaySet.questions = [q];
        displaySetList.push(displaySet);
      });
    });
    this._cachedDisplaySets = displaySetList;
    return displaySetList;
  }
  
  protected getNextQuestionSetToDisplay(assessment:Assessment, currentQuestionSet:QuestionSet) {
    let index = this._cachedDisplaySets.indexOf(currentQuestionSet);
    if (index >= 0 && index < this._cachedDisplaySets.length - 1) {
      return this._cachedDisplaySets[index + 1];
    }
    return null;
  }

  protected getPreviousQuestionSetToDisplay(assessment:Assessment, currentQuestionSet:QuestionSet) {
    let index = this._cachedDisplaySets.indexOf(currentQuestionSet);
    if (index > 0) {
      return this._cachedDisplaySets[index -1];
    }
    return null;
  }

  public nextSet() {
    if (this.hasNextSet) {
      if (this.hasUnansweredQuestions()) {
        	// display an alert
			  this.alertService.error("Please answer all of the questions before proceeding");
			  return;
      }
      jQuery(this.element.nativeElement.querySelector("#question-list")).fadeOut('fast', () => {
        super.nextSet();
        jQuery(this).fadeIn();
      }).fadeIn();
    }
  }

  public previousSet() {
    if (this.hasPreviousSet) {
      jQuery(this.element.nativeElement.querySelector("#question-list")).fadeOut('fast', () => {
          super.previousSet();
          if (!this.hasPreviousSet) {
            this.showInstructions(); // show the instructions if we've gone back to the beginning.
          }
        jQuery(this).fadeIn();
      }).fadeIn();
    }
    else {
      
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/assessments/assessment-single-question-display/assessment-single-question-display.component.ts